import React, { useEffect } from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Button, Grid, FormGroup, FormControlLabel, Checkbox } from "@mui/material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FileUploadIcon from "@mui/icons-material/FileUpload";
// import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import Zoom from "react-medium-image-zoom";

import { Formik, Form } from "formik";
import * as Yup from "yup";

import {
  
  makePostRequest,
  uploadFileRequest,
} from "../../../utils/utils";
import swal from "sweetalert";
import DoneIcon from "@mui/icons-material/Done";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const Validation_Schema = Yup.object().shape({
  // profile_pic: Yup.string().required("Required"),
  firstname: Yup.string()
    .trim("White spaces not allow")
    .strict(true)
    .required("Required")
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
      "Numbers/Special Characters Not Allowed!!"
    ),
  lastname: Yup.string()
    .trim("White spaces not allow")
    .strict(true)
    .required("Required")
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
      "Numbers/Special Characters Not Allowed!!"
    ),
  contact: Yup.string()
    .matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      "Phone number is not valid"
    )
    .min(10, "phone no must be 10 digits long")
    .max(10, "phone no must be 10 digits long")
    .required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  address: Yup.string().required("Required"),
  qualification: Yup.string().required("Required"),
});

function AddServiceProvider() {
  const navigate = useNavigate();

  const [pdfImage] = React.useState(
    require("../../../assets/Images/pdf.png")
  );
  const [txtImage] = React.useState(
    require("../../../assets/Images/text.png")
  );
  const [excelImage] = React.useState(
    require("../../../assets/Images/exel.png")
  );
  const [wordImage] = React.useState(
    require("../../../assets/Images/doc.png")
  );
  const [defaultProfilePic] = React.useState(
    require("../../../assets/Images/avtarPic.png")
  );

  //variables declration
  const [firstname, setfirstname] = React.useState("");
  const [lastname, setlastname] = React.useState("");
  const [contact, setcontact] = React.useState("");
  const [service_type, setServiceType] = React.useState("");
  const [age, setAge] = React.useState(0);
  const [address, setaddress] = React.useState("");
  const [documentsList, setDocumentsList] = React.useState([]);
  const [Update, setUpdate] = React.useState(false);
  const [qualification, setqualification] = React.useState("");
  const [profile_pic, setProfilePic] = React.useState("");
  const [showLoader, setShowLoader] = React.useState(false);
  const [isSentForApproval, setIsSentForApproval] = React.useState(true);
  const [serviceTypeList, setServiceTypeList] = React.useState([]);
  // if(props.name>0)
  // {
  //   var formikInitials = {
  //     profile_pic: profile_pic,
  //     firstname: firstname,
  //     lastname: lastname,
  //     contact: contact,
  //     email: email,
  //     address: address,
  //     qualification: qualification,
  //   };
  // }
  // else
  // {
  var formikInitials = {
    profile_pic: "",
    firstname: "",
    lastname: "",
    contact: "",
    service_type: "",
    age: 0,
    address: "",
    qualification: "",
  };
  // }


  async function GetActiveServiceTypeListing() {
    setShowLoader(true);
    const inputData = {
      sortBy: 'ASC',
      status: true,
    }

    await makePostRequest("servicetype/getalllisting", inputData)
      .then((response) => {
        if (response.data.data !== undefined) {

          if (response.data.data.rows.length > 0) {
            setServiceTypeList(response.data.data.rows)
          }
          else
            setServiceTypeList([])
        }
        setShowLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  // add Serviced Provider
  async function saveServiceProvider() {
    let status;
    if (isSentForApproval == true)
      status = 'pending'
    else
      status = 'approved'

    if (firstname && lastname && contact && service_type && age && address && qualification) {
      let inputdata = {
        profile_pic: profile_pic,
        firstname: firstname,
        lastname: lastname,
        contactno: contact,
        service_type: service_type,
        age: age,
        address: address,
        qualification: qualification,
        document_list: documentsList,
        is_sent_for_approval: isSentForApproval,
        status: status
      };

      await makePostRequest("serviceProvider/insert", inputdata)
        .then((response) => {
          if (response.data.data !== undefined) {
            swal("Success", "ServiceProvider Added Successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            navigate("/AllServiceProviders");
          } else {
          }
        })
        .catch((err) => {
          console.log(err);
          swal("There was an error!", "more error details", "warning");
        });


      setDocumentErrMsg("");
      setProfileErrMsg("");
    }

  }

  function validateImageOrFile(fileData) {
    if (
      fileData.name.match(
        /.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF|docx|DOCX|doc|DOC|pdf|PDF|xls|XLS|txt|TXT|xlsx|XLSX)$/i
      )
    )
      return true;
    else return false;
  }

  async function validateImage(fileData) {
    if (fileData.name.match(/.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/i))
      return true;
    else return false;
  }

  const [profileErrMsg, setProfileErrMsg] = React.useState("");
  const [documentErrMsg, setDocumentErrMsg] = React.useState("");

  async function uploadProfilePic(e) {

    setProfileErrMsg("")
    const file = e.target.files[0];
    alert(await validateImage(file));
    if (await validateImage(file)) {
      var profilePicUrl = await uploadImageOrFile(file);
      setProfilePic(profilePicUrl);
    }
    else
      setProfileErrMsg("Invalid File Format");
  }

  async function uploadImageOrFile(fileData) {
    const formData = new FormData();
    formData.append("image", fileData);
    var fileUrl;
    setShowLoader(true);
    await uploadFileRequest("guards/uploadImages", formData).then(
      (response) => {
        fileUrl = response.data.imagepath[0].location;
      }
    );
    setShowLoader(false);

    return fileUrl;
  }

  async function uploadDocuments(e) {
    // handle validations
    setDocumentErrMsg("");
    const file = e.target.files[0];
    if (await validateImageOrFile(file)) {
      var profilePicUrl = await uploadImageOrFile(file);

      documentsList.push(profilePicUrl);
      setDocumentsList(documentsList);
      setUpdate(!Update);
    }
    else {
      setDocumentErrMsg("Invalid Document Type")
    }
    // document.getElementById("doqumentDiv1").innerHTML.reload();
  }

  async function deleteDocument(index) {
    documentsList.splice(index, 1); // 2nd parameter means remove one item only
    setDocumentsList(documentsList);
    setUpdate(!Update);
  }

  async function handleChangeCheckbox(e) {
    setIsSentForApproval(e.target.checked)
  }

  async function handleChangeServiceType(e){

    // alert(e.target.value)
    if(e.target.value=='Add New')
      navigate('/ServiceTypePage')
    else 
      setServiceType(e.target.value)
  }
  useEffect(() => {
    GetActiveServiceTypeListing();
  }, [Update]);

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12}>
            <h1 className="panelHeading">
              {/* <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/ServiceProviders")}
              /> */}
              Add Service Provider
            </h1>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <div className="residentHeading">Service Provider Details</div>
            <div className="addAgencyMain">

              <Formik
                enableReinitialize
                initialValues={formikInitials}
                validationSchema={Validation_Schema}
                onSubmit={saveServiceProvider}
              >
                {({
                  values,
                  handleChange,
                  errors,
                  setFieldTouched,
                  touched,
                  isValid,
                  handleSubmit,
                }) => (
                  <Form>

                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <div className="tabLeftDiv">
                          <div className="uploadImDiv">
                            <div className="uploadIm">
                              {profile_pic ? (
                                <img src={profile_pic} />
                              ) : (
                                <img src={defaultProfilePic} />
                              )}
                            </div>
                            <div className="uploadInpu">
                              <FileUploadIcon />
                              <span>Upload Profile Photo</span>
                              <em className="uploadPhotoErrorMsg">
                                {profileErrMsg}
                              </em>
                              <input type="file" id="profile_pic" onChange={(event) =>
                                uploadProfilePic(event)
                              } />
                            </div>
                          </div>

                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">First Name</label>
                              <input className="inputSt" placeholder="First Name" value={values.firstname}
                                onChange={handleChange("firstname")}
                                onBlur={() => setFieldTouched("firstname")}
                                onChangeCapture={(e) =>
                                  setfirstname(e.target.value)
                                }
                              />
                              {errors.firstname && touched.firstname ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.firstname}
                                </div>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">Last Name</label>
                              <input className="inputSt" placeholder="Last Name" value={values.lastname}
                                onChange={handleChange("lastname")}
                                onBlur={() => setFieldTouched("lastname")}
                                onChangeCapture={(e) =>
                                  setlastname(e.target.value)
                                }
                              />
                              {errors.lastname && touched.lastname ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.lastname}
                                </div>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">Phone Number</label>
                              <input className="inputSt" placeholder="Phone   Number" value={values.contact}
                                maxLength={10}
                                onChange={handleChange("contact")}
                                onBlur={() => setFieldTouched("contact")}
                                onChangeCapture={(e) =>
                                  setcontact(e.target.value)
                                }
                              />
                              {errors.contact && touched.contact ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.contact}
                                </div>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">Service Type</label>

                              {/* <input className="inputSt" placeholder="Service Type" value={values.service_type}
                                onChange={handleChange("service_type")}
                                onBlur={() => setFieldTouched("service_type")}
                                onChangeCapture={(e) =>
                                  setServiceType(e.target.value)
                                }
                              /> */}


                              <select
                                className="inputSt"
                                value={service_type}
                                onChange={(e)=>handleChangeServiceType(e)}
                              >
                                <option value="" disabled>
                                  Select Society Type
                                </option>
                                {serviceTypeList.map(
                                  (option) => (
                                    <option
                                      key={option.service_name}
                                      value={option.service_name}
                                      data-isd={option.service_name}
                                    >
                                      {option.service_name}
                                    </option>
                                  )
                                )}

                                <option value="Add New" >
                                  Add New Service Type
                                </option>
                              </select>
                              {errors.service_type && touched.service_type ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.service_type}
                                </div>
                              ) : null}
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">Age</label>
                              <input className="inputSt" placeholder="Age" value={values.age}
                                maxLength={2}
                                onChange={handleChange("age")}
                                onBlur={() => setFieldTouched("age")}
                                onChangeCapture={(e) =>
                                  setAge(e.target.value)
                                }
                              />
                              {errors.age && touched.age ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.age}
                                </div>
                              ) : null}
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">Qualification</label>
                              <input
                                className="inputSt"
                                placeholder="Qualification"
                                value={values.qualification}
                                maxLength={10}
                                onChange={handleChange("qualification")}
                                onBlur={() => setFieldTouched("qualification")}
                                onChangeCapture={(e) =>
                                  setqualification(e.target.value)
                                }
                              />
                              {errors.qualification && touched.qualification ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.qualification}
                                </div>
                              ) : null}
                            </Grid>

                            <Grid item xs={12} md={12}>
                              <label className="tabsLabel">Address</label>
                              <textarea
                                className="textAriaSt"
                                placeholder="Address"
                                value={values.address}
                                onChange={handleChange("address")}
                                onBlur={() => setFieldTouched("address")}
                                onChangeCapture={(e) =>
                                  setaddress(e.target.value)
                                }
                              />
                              {errors.address && touched.address ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.address}
                                </div>
                              ) : null}
                            </Grid>
                          </Grid>

                        </div>
                      </Grid>
                      {/* <Grid item xs={12} md={6}>
                  <div className="tabRightDiv">
                    <h4 className="documeUpload">Documents Upload</h4>
                    <div className="doqumentDiv1 noPaddLeft">
                      <span>Adhaar Card</span>
                      <FileUploadIcon />
                      <input type="file" />
                    </div>
                    <div className="doqumentDiv2">
                      <span>PAN Card</span>
                      <div className="progresDoneOut">
                        <div className="progresDone"></div>
                        <CloseIcon />
                      </div>
                      <p>PAN Card</p>
                    </div>
                    <div className="doqumentDiv1 noPaddLeft">
                      <span>Driving Licence </span>
                      <FileUploadIcon />
                      <input type="file" />
                    </div>
                    <div className="doqumentDiv1 noPaddLeft">
                      <span>Other Document 1</span>
                      <FileUploadIcon />
                      <input type="file" />
                    </div>
                    <div className="doqumentDiv1 noPaddLeft">
                      <span>Other Document 2</span>
                      <FileUploadIcon />
                      <input type="file" />
                    </div>

                  </div>
                </Grid> */}

                      <Grid item xs={12} md={6}>
                        <div className="tabViewOfProviderRight">
                          <h4 className="doquProviderHed">
                            Documents
                          </h4>
                          <div className="societyDoc">
                            <h4 className="documeUpload documeUploadIcon">
                              Upload Documents
                              <Button className="forUploadOnly">
                                <FileUploadIcon />
                                <input
                                  type="file"
                                  style={{
                                    opacity: 0,
                                    position: "absolute",
                                    left: 0,
                                  }}
                                  id="documentsList"
                                  value={values.documentsList}
                                  onChange={(event) =>
                                    uploadDocuments(
                                      event,
                                      "resident"
                                    )
                                  }
                                  onChangeCapture={() =>
                                    setDocumentsList(
                                      documentsList
                                    )
                                  }
                                />
                              </Button>
                            </h4>
                          </div>
                          {documentErrMsg ? (
                            <div className="errorField errorFieldFForLogin forInvalidFile">
                              {documentErrMsg}
                            </div>
                          ) : (
                            <></>
                          )}
                          {documentsList ? (
                            <>
                              <div className="docScrollBar">
                                {documentsList.map(
                                  (option, index) => (
                                    <div
                                      id="documentDiv"
                                      className="doqumentDiv1"
                                    >
                                      <Zoom>
                                        <div className="doquView">
                                          {option
                                            .split(".")
                                            .pop() == "txt" ? (
                                            <img src={txtImage} />
                                          ) : option
                                            .split(".")
                                            .pop() == "pdf" ? (
                                            <img src={pdfImage} />
                                          ) : option
                                            .split(".")
                                            .pop() == "docx" ||
                                            option
                                              .split(".")
                                              .pop() == "doc" ? (
                                            <img
                                              src={wordImage}
                                            />
                                          ) : option
                                            .split(".")
                                            .pop() == "xls" ||
                                            option
                                              .split(".")
                                              .pop() == "xlsx" ? (
                                            <img
                                              src={excelImage}
                                            />
                                          ) : (
                                            <img src={option} />
                                          )}
                                        </div>
                                      </Zoom>
                                      <span>
                                        <a href={option}>
                                          {option
                                            .split("/")
                                            .pop()
                                            .replace("%20", " ")}
                                        </a>
                                        <DoneIcon className="doneIcon" />{" "}
                                      </span>

                                      <Button
                                        className="documRemove"
                                        onClick={() =>
                                          deleteDocument(
                                            "resident",
                                            index
                                          )
                                        }
                                      >
                                        <DeleteForeverIcon className="deleIco" />
                                      </Button>
                                    </div>
                                  )
                                )}
                              </div>
                            </>
                          ) : (
                            <span>No Documents Uploaded yet</span>
                          )}
                        </div>
                      </Grid>

                      <Grid item xs={12} md={12}>
                        <FormGroup>
                          <FormControlLabel control={<Checkbox />}
                            label="Need Approval from society commitee?"
                            checked={isSentForApproval}
                            onChange={(e) =>
                              handleChangeCheckbox(e)
                            } />

                        </FormGroup>
                      </Grid>

                      <Grid item xs={12} md={12}>
                        <div
                          className="addOwnerTopLine cancelBtForAllOuter"
                          style={{ textAlign: "center" }}
                        >
                          <Button className="addBt cancelBtForAll" onClick={() => navigate("/AllServiceProviders")}>
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            className="addBt"
                            onClick={saveServiceProvider}
                          >

                            <div> Add </div>

                          </Button>
                        </div>
                      </Grid>
                    </Grid>

                  </Form>
                )}
              </Formik>
            </div>

          </Grid>
        </Grid>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default AddServiceProvider;
